// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"423":"810e9ef7","497":"d67523c0"}[chunkId] + ".css";
};